import React from 'react'
import { API_SERVICES } from '..'
import QSubcategoria from '../../libQuestionario/pages/QSubcategoria'
import PDTAHeader from './components/PDTAHeader'


const PDTASubcategoria = () => {
  return <QSubcategoria
    homeRoute={API_SERVICES.PDTA.HOME_ROUTE}
    root={API_SERVICES.PDTA.ROOT}
    title={API_SERVICES.PDTA.NOME}
    headerComponent={<PDTAHeader label="Seleziona un modello" />}
  />
}

export default PDTASubcategoria;